import { Container, Row } from "reactstrap";
import { CkEditor, Editors } from "../../../../constants";
import Editor from "./Editor";
import InlineEditor from "./InlineEditor";
import Breadcrumbs from "../../../../coreComponents/breadcrumbs";

const CkEditorContainer = () => {

  return (
    <>
      <Breadcrumbs mainTitle={CkEditor} parent={Editors} />
      <Container fluid>
        <Row>
          <Editor />
          <InlineEditor />
        </Row>
      </Container>
    </>
  );
};

export default CkEditorContainer;